var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 57,
    viewBox: "0 0 48 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.333313,
    width: 48,
    height: 56,
    rx: 4,
    fill: "#00AEEF",
    fillOpacity: 0.05
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.0306 24.0527L26.7806 18.8027C26.7109 18.7331 26.6282 18.6779 26.5371 18.6402C26.4461 18.6026 26.3485 18.5832 26.25 18.5833H17.25C16.8522 18.5833 16.4706 18.7413 16.1893 19.0227C15.908 19.304 15.75 19.6855 15.75 20.0833V36.5833C15.75 36.9811 15.908 37.3627 16.1893 37.644C16.4706 37.9253 16.8522 38.0833 17.25 38.0833H30.75C31.1478 38.0833 31.5294 37.9253 31.8107 37.644C32.092 37.3627 32.25 36.9811 32.25 36.5833V24.5833C32.2501 24.4848 32.2307 24.3872 32.1931 24.2962C32.1555 24.2051 32.1003 24.1224 32.0306 24.0527ZM26.25 24.5833V20.4583L30.375 24.5833H26.25Z",
    fill: "#01AEEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/fileIcon.107619c0bde345d329d1bdf1a41038af.svg";
export { ForwardRef as ReactComponent };